import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { SpinnerService } from '../../../services/spinner.service';
import { ApiBaseAttribute, ApiSetExhibitDetailAttributesRequest } from '../../../api-client-module';
import { ProjectLanguage } from '../../../firestore-models/project-language';

import { ConfigurationService } from '../../../configuration.service';
import { ApiClientService } from '../../../api-client.service';
import { AppConst } from '../../../app-const';
import { MultiNameDialogComponent } from '../../../common/multi-name-dialog/multi-name-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface ExhibitDetailAttributeDialogData {
  change_type: number;
  exhibitDetailAttribute?: ApiBaseAttribute;
}

@Component({
  selector: 'app-exhibit-detail-attribute-dialog',
  templateUrl: './exhibit-detail-attribute-dialog.component.html',
  styleUrls: ['./exhibit-detail-attribute-dialog.component.css'],
  standalone: false,
})
export class ExhibitDetailAttributeDialogComponent implements OnInit {

  projectId: string;
  //展示属性情報
  exhibitDetailAttribute?: ApiBaseAttribute;
  isAdded: boolean = false;
  projectLanguages!: Array<ProjectLanguage>;

  //展示属性情報フォーム
  exhibitDetailAttributeFormGroup!: FormGroup;
  exhibitDetailAttributeIdControl!: FormControl;
  exhibitDetailAttributeNameControl!: FormControl;

  // ユーザータイプ
  readonly USER_TYPE_USER: number = AppConst.MANAGE_USER_TYPE_USER;
  userType!: number;
  isEdit: boolean = false;

  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<ExhibitDetailAttributeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExhibitDetailAttributeDialogData,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private configurationService: ConfigurationService,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) {
    this.projectId = this.configurationService.getProjectId();
    this.userType = this.configurationService.getUserType();
    this.isEdit = this.configurationService.getIsEdit();
  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
    this.exhibitDetailAttribute = this.data.exhibitDetailAttribute;
    if (!this.exhibitDetailAttribute) {
      this.exhibitDetailAttribute = {
        attribute_id: '',
        attribute_names: [],
        project_id: this.projectId,
        enabled: true
      };
      this.isAdded = true;
    }
    this.createForm();
    this.exhibitDetailAttributeIdControl = this.exhibitDetailAttributeFormGroup.get('exhibitDetailAttributeId') as FormControl;
    this.exhibitDetailAttributeNameControl = this.exhibitDetailAttributeFormGroup.get('exhibitDetailAttributeName') as FormControl;
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToExhibitDetailAttributeId() {
    return this.exhibitDetailAttributeIdControl.hasError('required')
    ? this.translate.instant('必須項目')
    : this.exhibitDetailAttributeIdControl.hasError('pattern')
    ? this.translate.instant('半角数字')
    : '';
  }

  public getErrorMessageToExhibitDetailAttributeName() {
    return this.exhibitDetailAttributeNameControl.hasError('required')
    ? this.translate.instant('必須項目')
    : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.exhibitDetailAttributeFormGroup = this.formBuilder.group(
      {
        exhibitDetailAttributeId: [this.exhibitDetailAttribute!.attribute_id, [Validators.required, Validators.pattern('^[0-9]+$')]],
        exhibitDetailAttributeName: [this.exhibitDetailAttribute!.attribute_names, [Validators.required]]
      }
    );
  }

  //更新ボタン
  addExhibitDetailAttribute(): void {
    if (this.exhibitDetailAttributeFormGroup.valid) {
      this.exhibitDetailAttribute!.attribute_id = this.exhibitDetailAttributeIdControl.value;
      this.exhibitDetailAttribute!.attribute_names = this.exhibitDetailAttributeNameControl.value;
      if (this.exhibitDetailAttribute) {
        let request: ApiSetExhibitDetailAttributesRequest = {
          access_token: '',
          change_type: this.data.change_type,
          attributes: [this.exhibitDetailAttribute]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setExhibitDetailAttributes(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //属性名称ダイアログ
  openAttributeNameDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.exhibitDetailAttribute!.attribute_names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.exhibitDetailAttribute!.attribute_names = result;
        this.exhibitDetailAttributeNameControl.setValue(this.exhibitDetailAttribute!.attribute_names);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
